import {
    REQUEST_REDIRECT,
    UPDATE_LOADING_STATUS,
    UPDATE_TEMPLATE,
    UPDATE_ITEM_LIST,
    UPDATE_UNIT_LIST,
    UPDATE_ESTATE_LIST,
    UPDATE_LOCATION_LIST,
    UPDATE_ITEM_SMART_SUGGESTION_LIST,
} from '../ActionTypes'
import _ from 'lodash'

const API_URL = process.env.API_URL

// REQUEST redirect
export const requestRedirect = (target) => {
    return {
        type: REQUEST_REDIRECT,
        payload: target
    }
}

// FETCH Estate List
const requestEstateList = () => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: []
    }
}

const receiveEstateList = (array) => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: array
    }
}

export const fetchEstateList = (token) => {
    return dispatch => {
        dispatch(requestEstateList())
        return fetch(`${API_URL}/suggest/estate`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveEstateList(json.result)))
    }
}

// FETCH Location List
const requestLocationList = () => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: []
    }
}

const receiveLocationList = (array) => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: array
    }
}

export const fetchLocationList = (token) => {
    return dispatch => {
        dispatch(requestLocationList())
        return fetch(`${API_URL}/suggest/location`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveLocationList(json.result)))
    }
}

// FETCH item list
const requestItemList = () => {
    return {
        type: UPDATE_ITEM_LIST,
        payload: []
    }
}

const receiveItemList = (array) => {
    return {
        type: UPDATE_ITEM_LIST,
        payload: array
    }
}

export const fetchItemList = (token) => {
    return dispatch => {
        dispatch(requestItemList)
        return fetch(`${API_URL}/suggest/item`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveItemList(json.result)))
    }
}

export const removeItemName = (token, itemName) => {
    return dispatch => {
        return fetch(`${API_URL}/suggest/item`, {
                method: 'DELETE',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ item: itemName })
            })
            .then(response => response.json())
            .then(json => fetch(`${API_URL}/suggest/item`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }))
            .then(response => response.json())
            .then(json => dispatch(receiveItemList(json.result)))
    }
}


// FETCH unit list
const requestUnitList = () => {
    return {
        type: UPDATE_UNIT_LIST,
        payload: []
    }
}

const receiveUnitList = (array) => {
    return {
        type: UPDATE_UNIT_LIST,
        payload: array
    }
}

export const fetchUnitList = (token) => {
    return dispatch => {
        dispatch(requestUnitList)
        return fetch(`${API_URL}/suggest/unit`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveUnitList(json.result)))
    }
}

// FETCH item smart suggestion list
const requestItemSmartSuggestionList = () => {
    return {
        type: UPDATE_ITEM_SMART_SUGGESTION_LIST,
        payload: {
            loading: true,
            suggestionList: []
        }
    }
}

const receiveItemSmartSuggestionList = (keyword, array) => {
    return {
        type: UPDATE_ITEM_SMART_SUGGESTION_LIST,
        payload: {
            loading: false,
            keyword: keyword,
            suggestionList: array
        }
    }
}


export const fetchItemSmartSuggestionList = (token, keyword, filter) => {
    return dispatch => {
        const filterQuery = _.map(filter, (value, key) => {
            if (value !== undefined)
                return `${key}=${encodeURIComponent(value)}`
        })
        dispatch(requestItemSmartSuggestionList())
        return fetch(`${API_URL}/suggest/smart-item?keyword=${encodeURIComponent(keyword)}${filterQuery.length > 0 ? '&' + filterQuery.join('&'): ''}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveItemSmartSuggestionList(keyword, json.result)))
    }
}

// FETCH/UPDATE Template
const startSaving = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Saving...'
        }
    }
}

const endSaving = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

const requestTemplate = () => {
    return {
        type: UPDATE_TEMPLATE,
        payload: {}
    }
}

const receiveTemplate = (json) => {
    return {
        type: UPDATE_TEMPLATE,
        payload: json
    }
}

export const fetchTemplate = (token, templateId) => {
    return dispatch => {
        dispatch(requestTemplate())
        return fetch(`${API_URL}/template/${templateId}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveTemplate(json.result)))
    }
}

export const saveTemplate = (token, backgroundInformation, content, termsAndConditions, appendix) => {
    return dispatch => {
        dispatch(startSaving())
        return fetch(`${API_URL}/template`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ backgroundInformation, content, termsAndConditions, appendix })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveTemplate(json.result)))
            .then(() => dispatch(endSaving()))
    }
}

export const updateTemplate = (token, templateId, backgroundInformation, content, termsAndConditions, appendix) => {
    return dispatch => {
        dispatch(startSaving())
        return fetch(`${API_URL}/template/${templateId}`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ backgroundInformation, content, termsAndConditions, appendix })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveTemplate(json.result)))
            .then(() => dispatch(endSaving()))
    }
}

const startDeleting = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: true,
            tip: 'Deleting...'
        }
    }
}

const endDeleting = () => {
    return {
        type: UPDATE_LOADING_STATUS,
        payload: {
            isLoading: false
        }
    }
}

export const deleteTemplate = (token, templateId) => {
    return dispatch => {
        dispatch(startDeleting())
        return fetch(`${API_URL}/template/${templateId}`, {
                method: 'DELETE',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            })
            .then(response => response.json())
            .then(json => dispatch(requestRedirect('/workdesk/template')))
            .then(() => dispatch(requestRedirect('')))
            .then(() => dispatch(endDeleting()))
    }
}


// WEBPACK FOOTER //
// ./src/TemplateEditPage/TemplateEditPageActions.js